import { isMobileWebView, postMobileDownloadCsv } from 'helpers/mobileWebView';

function escapeCsvValue(value) {
  const val = value ?? '';
  if (typeof val === 'string') {
    return `"${val.replace(/"/g, '""')}"`;
  }
  return val;
}

export function buildCsvString(columns, rows) {
  const csvRows = [columns.map(c => c.label).join(',')];

  for (const row of rows) {
    csvRows.push(columns.map(c => escapeCsvValue(row[c.key])).join(','));
  }

  return csvRows.join('\n');
}

export default function downloadCsv({ filename, columns, rows }) {
  if (!rows?.length) return;

  const csvString = buildCsvString(columns, rows);

  if (isMobileWebView()) {
    postMobileDownloadCsv(csvString, filename);
    return;
  }

  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
